module.exports = __webpack_public_path__ + "media/images/icons/filled/file-markdown-fb8c4488e28e6bd5e9b003167f3a5dc9.svg";